/**
 * BreadCrumbs - breadcrumb trail navigation.
 * Custom element: <bread-crumbs>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class BreadCrumbs extends ThemeComponent {}
setFunctionName(BreadCrumbs, "BreadCrumbs");
const propertyTypes = {};
BreadCrumbs.prototype.$name = "BreadCrumbs";
BreadCrumbs.prototype.$info = JSON.parse('{"name":"BreadCrumbs","meta":{"isLegacy":false,"selector":"bread-crumbs"},"props":[],"refs":[]}');
BreadCrumbs.prototype.$info.component = BreadCrumbs;
for (const prop of BreadCrumbs.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("BreadCrumbs/BreadCrumbs.ts", {
  BreadCrumbs: BreadCrumbs
}, void 0);